import React, { FC } from 'react'
import ScreenLayout from 'components/ScreenLayout'
import AuthCallbackX from 'components/AuthCallbackX'

const AuthCallbackXScreen: FC = () => (
  <ScreenLayout disableModal>
    <AuthCallbackX />
  </ScreenLayout>
)

export default AuthCallbackXScreen